import { inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@softline/core';
import { handleRequestError } from '@softline/application';
import { askFn, modalFn, translator } from '@softline/ui-core';
import { SOFTLINE_FEATURE_KOMMISSIONIERUNG } from '../kommissionierung.shared';
import { KommissionierungStore } from '../store';
import { KommissionsauftragKopf } from '../types/kommissionsauftrag';
import { SelectKopfkommModal } from '../dialogs/select-kopfkomm-modal/select-kopfkomm-modal';

@Injectable({ providedIn: 'root' })
export class OffeneKopfkommsService {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly injector = inject(Injector);
  private readonly t = translator();
  private readonly modal = modalFn();
  private readonly ask = askFn();

  async selectAndTakeOver(orders: KommissionsauftragKopf[]): Promise<void> {
    const target = await this.modal({
      title: this.t('#KOMMISSIONIERUNG.DIALOGS.OFFENE_AUFTRAEGE.TITLE')(),
      component: SelectKopfkommModal,
      separateContentSection: true,
      data: { orders },
    });
    if (!target || target === 'DISMISSED') return;
    await this.takeOver(target);
  }

  async takeOver(target: KommissionsauftragKopf): Promise<boolean> {
    try {
      try {
        await this.sperre(target.id, false);
      } catch {
        const result = await this.ask({
          title: this.t('#KOMMISSIONIERUNG.DIALOGS.OFFENE_AUFTRAEGE.TITLE'),
          question: this.t('#KOMMISSIONIERUNG.DIALOGS.QUESTION.FORCE_ÜBERNAHME', {
            anwender: target.anwender?.anwender ?? '',
          }),
          dismiss: true,
        });
        if (result !== 'YES') return false;
        await this.sperre(target.id, true);
      }
      await this.store.dispatch(
        SOFTLINE_FEATURE_KOMMISSIONIERUNG,
        KommissionierungStore.actions.load,
        { id: target.id }
      );
      await this.router.navigate([
        target.mischpalette ? '/vorkommissionierung' : '/kommissionierung',
        target.id,
      ]);
      return true;
    } catch (e) {
      handleRequestError(e, this.injector, { show: true });
      return false;
    }
  }

  private sperre(idkopfkomm: number, force: boolean): Promise<unknown> {
    return this.store.dispatch(
      SOFTLINE_FEATURE_KOMMISSIONIERUNG,
      KommissionierungStore.actions.sperre,
      { idkopfkomm, force }
    );
  }
}
